export function speakWelcome(name) {
    if (typeof window === "undefined" || !window.speechSynthesis) return;
    try {
        const greetings = [
            `Welcome to Tresses, ${name}. Your sanctuary of elegance awaits.`,
            `Hello ${name}, beautiful to see you. Let’s craft something timeless today.`,
            `${name}, welcome back to Tresses. Pure indulgence, just for you.`,
        ];
        const text = greetings[Math.floor(Math.random() * greetings.length)];
        const utter = new SpeechSynthesisUtterance(text);
        utter.rate = 0.95;
        utter.pitch = 1.0;
        utter.volume = 0.9;
        const voices = window.speechSynthesis.getVoices();
        const preferred = voices.find((v) => /female|samantha|victoria|karen|tessa|google.*english/i.test(v.name)) || voices[0];
        if (preferred) utter.voice = preferred;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(utter);
    } catch (e) {
        // silent fail
    }
}
